import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import TextAreaField from '@/components/forms/new/formikFormFields/TextAreaField';
import TriggerFieldToolTip from './TriggerFieldToolTip';
import { useTriggerForm } from '../useTriggerForm.js';
import { FORM_FIELD_PATHS } from '../triggerFormConstants.js';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const TriggerDescription = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useTriggerForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.DESCRIPTION, e.target.value);
    };

    return (
        <Box marginTop="20px">
            <FormControl
                sx={{ margin: '0 !important', position: 'relative' }}
                isInvalid={!!errors?.description && touched?.description}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <Stack
                    direction="row"
                    spacing={stackSpacing}
                    align="flex-start"
                    sx={{ ...stackStyling(), height: 'auto' }}>
                    <FormLabel
                        htmlFor="description"
                        sx={formLabelStyling(darkMode)}>
                        Description
                    </FormLabel>
                    <Box flex={1} maxWidth="400px">
                        <Field
                            component={TextAreaField}
                            id="description"
                            name="description"
                            value={formData?.description || ''}
                            onChange={handleChange}
                            placeholder="Enter trigger description (optional)"
                            width="100%"
                            rows={3}
                        />
                        <TriggerFieldToolTip
                            isVisible={isHovered}
                            label="Provide an optional description for this trigger"
                            ariaLabel="trigger-description-tip"
                        />
                    </Box>
                </Stack>
            </FormControl>
        </Box>
    );
};

export default TriggerDescription;
